module.exports = __webpack_public_path__ + "media/images/icons/filled/audio-c037d64bda1d26b8a89ac6c97fe9c80a.svg";